import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m258-484 126 125q11 12 11 28-1 16-12 28-12 12-28 12-17 0-28-12L134-496q-12-11-12-28t12-28l194-194q11-12 28-12 16 0 28 12 11 12 11 29t-11 27L258-564h389q88 0 148 60t60 148v131q0 16-12 28-12 11-28 11-17 0-29-11-11-12-11-28v-131q0-57-36-92t-92-36H258Z"/>',
  f: '<path d="m258-484 126 125q11 12 11 28-1 16-12 28-12 12-28 12-17 0-28-12L134-496q-12-11-12-28t12-28l194-194q11-12 28-12 16 0 28 12 11 12 11 29t-11 27L258-564h389q88 0 148 60t60 148v131q0 16-12 28-12 11-28 11-17 0-29-11-11-12-11-28v-131q0-57-36-92t-92-36H258Z"/>',
};

export default data;
